module.exports = __webpack_public_path__ + "static/media/watch-and-logo.5eac8b99.png";